import { NetworkIds } from './rpcConfig';

export const VestaGraphConfig: {
  [key in NetworkIds]: string;
} = {
  [NetworkIds.ARBITRUM_ONE]: 'https://api.thegraph.com/subgraphs/name/shinitakunai/vestafinance-v1_7',
  [NetworkIds.ARBITRUM_RINKEBY]: '',
} as const;
